/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import Header from '../../components/header';
import { Route } from 'react-router-dom';
import RouteErrorBoundary from '../../components/error/RouteErrorBoundary';
import { AppLayout } from '../../layout/AppLayout';
import React from 'react';
import { AppRouteInterface, RouteInterface } from '../../types/routes';
import { AppHeader } from '../../components/header/AppHeader';
import { WaitingComponent } from '../../utils/component';
import WTLogo from '../../images/World_tracker_logo.svg';


const WorldTracker = React.lazy(() => import('./index'));
export const worldTrackerRoute: RouteInterface = {
  id: 'world_tracker',
  label: 'Countdown to 2030',
  path: '/world-tracker',
  icon: 'fa-globe',
  tooltip: 'World Tracker - Countdown to 2030',
  component: WaitingComponent(WorldTracker)
}

export const worldTrackerRouteEntry: RouteInterface = {
  ...worldTrackerRoute,
  exact: false,
  id: 'world_tracker_entry',
  component: WorldTrackerRoute
}

const worldTrackerAppRoute: AppRouteInterface = {
  appName: 'World Tracker',
  appIcon: WTLogo,
  routes: [worldTrackerRoute],
  hasSidebar: false
}

export function WorldTrackerRoute() {

  const component = (props: any) => (
    <Header {...props} className={'responsivePage'}>
      <AppHeader appRoute={worldTrackerAppRoute} route={worldTrackerRoute} />
    </Header>
  );

  return (
    <RouteErrorBoundary>
      <AppLayout Header={<Route path={worldTrackerRoute.path} component={component} />}>
        <Route {...worldTrackerRoute} />
      </AppLayout>
    </RouteErrorBoundary>
  )
}

